import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { AccountMenuContainer } from '@/components/pages/Account/Index/AccountMenu';

export const AccountPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.account.index.title');

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
      hasHeaderDivider={true}
    >
      <AccountMenuContainer />
    </PageRootWrapper>
  );
};
